import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'offer-availability:available-at-locations': {
    id: 'offer-availability:available-at-locations',
    defaultMessage: 'Available at {count, plural, one {# location} other {# locations}}',
    description: 'Text showing how many locations an offer is available at',
  },
  'offer-availability:could-be-unavailable-nearby': {
    id: 'offer-availability:could-be-unavailable-nearby',
    defaultMessage: 'Could be unavailable nearby',
    description: 'Text indicating that the offer might not be available at nearby locations',
  },
});
